module.exports = __webpack_public_path__ + "static/media/checkoutMoreGames.a4ff54a5.png";